import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'g10-ms-icon',
  templateUrl: './icon.component.html',
  styles: [`
      .grow{
        transition: all .5s ease-in-out
      }
      .grow:hover {
        transform: scale(1.1)
      }
      .tablebtnSuccess{
        color: green;
      }
      .warn{
        color: #C50E2E;
        margin-left: 1rem;
      }
      .fs-13{
        font-size: 13px !important;
      }
  `]
})
export class IconComponent implements OnInit {

  @Input() icon: any;
  @Input() mat: boolean;
  @Input() id:string;
  @Input() class:string = '';
  @Output() click: EventEmitter<string> = new EventEmitter<string>();



  constructor() { }

  ngOnInit() {

  }

  onIconClick() {
    this.click.emit('You have clicked on a icon.');
  }

}
